import React, { useEffect, useState } from 'react';
import { Row, Col, OverlayTrigger, Tooltip, Button, Popover } from 'react-bootstrap';
import UserService from '../../controllers/UserService';
import AuthService from '../../controllers/AuthService';

const FriendshipGame = props => {

    const [classList, setClassList] = useState([]);
    const filterYear = props.year ?? null
    const filterTerm = props.term ?? null
    const filterGrade = props.grade ?? null
    const filterGradeYear = props.gradeYear ?? null
    // const roomId = props.roomId ?? null
    const [gradeYearSelected, setGradeYearSelected] = useState(null);
    const [gradeYearSelection, setGradeYearSelection] = useState(null);
    const showHeader = props.showHeader ?? true
    const showFilterGradeYear = props.showFilterGradeYear ?? true
    const user = AuthService.getCurrentUser();

    useEffect(() => {
        if (!filterYear || !filterTerm || !filterGrade || (filterGrade && !(filterGrade.includes("PRIMARY") || filterGrade.includes("SECONDARY")))) {
            return;
        }
        console.log('build !')
        console.log('filterGradeYear', filterGradeYear)

        loadAPI(filterGradeYear)

    }, [filterYear, filterTerm, filterGrade, filterGradeYear, showHeader])

    const loadAPI = (gradeYearVal) => {
        const filterGradeCompute = filterGrade.includes("PRIMARY") ? "PRIMARY_SCHOOL" : "SECONDARY_SCHOOL"
        const filterGradeComputeTH = filterGrade.includes("PRIMARY") ? "ป." : "ม."

        const filter = {
            "domain": user.domain.name,
            "year": filterYear,
            "term": filterTerm,
            "grade": filterGradeCompute,
        };
        UserService.getFriendshipGameReport(filter).then((response) => {
            let result = []
            if (response.data?.data?.length > 0) {
                const data = response.data.data
                const gradeYearFilter = gradeYearSelectionCompute(gradeYearVal, data)
                const dataFilter1 = data.filter(function (val) { return val.gradeYear === parseInt(gradeYearFilter) });
                const dataSorted = dataFilter1.sort(function (a, b) {
                    return a.roomNo - b.roomNo;
                })
                for (const [index, value] of dataSorted.entries()) {
                    let classNameTH = filterGradeComputeTH + value.gradeYear + '/' + value.roomNo
                    result.push({
                        // className: classNameTH, progress: value.score * 100 / 88, score: value.score
                        className: classNameTH, progress: value.score, score: value.score
                    })
                }

            } else {
                setGradeYearSelection(null)
            }
            setClassList(result)
        });
    }

    const getPlayGameLink = () => {
        if (AuthService.getUserRole() === 'teacher') {
            return `/evaluate/${AuthService.getCurrentRoomId()}/overview`
        } else if (AuthService.getUserRole() === 'student') {
            return `/evaluate/${AuthService.getCurrentRoomId()}`
        }
        return '#'
    }

    const gradeYearSelectionCompute = (val = null, data = null) => {
        if (val) return val
        let result = []
        if (data && data.length > 0) {
            const filterGradeCompute = filterGrade.includes("PRIMARY") ? "PRIMARY_SCHOOL" : "SECONDARY_SCHOOL"
            const filterGradeComputeTH = filterGrade.includes("PRIMARY") ? "ประถม" : "มัธยม"
            const dataInClass = data.filter(function (val) { return val.grade === filterGradeCompute });
            for (let i = 1; i <= 6; i++) {
                const search = data.filter(function (val) { return val.gradeYear === i });
                if (search.length > 0) {
                    result.push({
                        value: filterGrade + '_' + i,
                        text: filterGradeComputeTH + ' ' + i,
                    })
                }
            }
            setGradeYearSelected(null)
            console.log(result, 'result')
        }
        setGradeYearSelection(result)

    }

    const dropdownGradeYearCompute = (e) => {
        console.log('selectedVal dropdownGradeYearCompute')
        let selectedVal = e?.target?.value ?? null
        if (selectedVal) {
            const splitVal = selectedVal.split("_")
            if (splitVal && splitVal.length > 1) {
                loadAPI(splitVal[1])
            }
        }
        setGradeYearSelected(selectedVal)
        return;
    }

    return (
        <>
            {(((classList && classList.length > 0) || (gradeYearSelection && gradeYearSelection.length > 0)) && showHeader) ?
                <>
                    <Row className="font-sarabun mt-3 mb-3 mt-lg-5 mb-lg-4">
                        <Col xs={12} className="text-center">
                            <h2 className="font-sarabun-bold mb-0">
                                MindsetMaker Friendship FunRun
                            </h2>
                            {/* <button className="btn-showhide border-gray showhide-red d-none d-lg-inline" id="showHideClassesSummary" onClick={() => showHideSection('showHideClassesSummary')}> </button> */}
                        </Col>
                        <Col xs={12} className='mt-3 text-left'>
                            <div>
                                เตรียมตัวให้พร้อมกับกิจกรรมที่จัดแค่เทอมละครั้ง!! การแข่งขันเริ่มต้นขึ้นแล้ว! งานนี้ทุกคนจำเป็นต้องทำงานเป็นทีม"คุณเพื่อน และคุณครูประจำชั้น” ต้องร่วมมือร่วมใจกัน ภายใต้เป้าหมายเดียวกันคือพา“น้องเปิดใจ”เข้าเส้นชัยก่อนใคร
                            </div>
                            <div className='font-sarabun-bold'>
                                กติกา: ในการทำประเมินทุกครั้งของกิจกรรม Friendship จะทำให้ตัวละครในสนามเคลื่อนที่ไปข้างหน้าเช่น การประเมินตัวเอง การประเมินเพื่อน หรือคุณครูประเมินตัวเอง
                            </div>
                        </Col>
                    </Row>
                </>
                : null}
            {(((classList && classList.length > 0) || (gradeYearSelection && gradeYearSelection.length > 0)) && showFilterGradeYear) ?
                <Row>
                    <Col xs={12} lg={3} className='font-sarabun-bold d-flex mb-3'>
                        <div className='d-inline ne-headmaster-label-dropdown'>เลือกระดับชั้น </div>
                        <div className='d-inline ml-3'>
                            <select class="form-control form-control-sm border-radius-5 font-sarabun main-dropdown" onChange={dropdownGradeYearCompute}>
                                <option disabled selected={!gradeYearSelected || !gradeYearSelection || gradeYearSelection.length === 0}>เลือก</option>
                                {
                                    (gradeYearSelection && gradeYearSelection.length > 0) ? (
                                        gradeYearSelection.map((item, index) => (
                                            <option value={item.value} key={index}>{item.text}</option>
                                        ))
                                    ) : (
                                        null
                                    )
                                }
                            </select>
                        </div>
                    </Col>
                </Row>
                : null}

            {(classList && classList.length > 0) ?
                <Row className='friendship-game'>
                    {/* Banner */}
                    <Col xs={12} className='position-relative'>
                        <img src='/images/friendship-game/banner-mb.jpg' className='w-100 d-inline d-lg-none' />
                        <img src='/images/friendship-game/banner-dt.jpg' className='w-100 d-none d-lg-inline' />
                        {(AuthService.getUserRole() !== 'headmaster') ?
                            <Button className='position-absolute bluesky d-none d-lg-flex playgame' href={getPlayGameLink()}>PLAY GAME</Button>
                            : null}
                    </Col>
                    {/* Race Lane */}
                    {classList.length > 0 && classList.map(function (cRoom, i) {
                        return (
                            <>
                                <Col xs={12} key={i}>
                                    <div className="full-lane">
                                        <div className="roomName font-sarabun">{cRoom.className}</div>
                                        <div className="roomLane">
                                            <OverlayTrigger
                                                placement="top"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={<Tooltip id="tooltip-disabled" className='custom-tooltop-friendship-game'>{cRoom.score} %</Tooltip>}
                                            >
                                                <img src='/images/friendship-game/mascot.gif' className="mascot" style={{ "left": cRoom.progress + "%" }} />
                                            </OverlayTrigger>
                                        </div>
                                    </div>
                                </Col>

                            </>
                        );
                    })}
                    {(AuthService.getUserRole() !== 'headmaster') ?
                        <Col xs={12} className='d-lg-none text-center mt-3'>
                            <Button className='bluesky' href={getPlayGameLink()}>PLAY GAME</Button>
                        </Col>
                        : null}
                </Row>
                : null}
        </>
    )



}

export default FriendshipGame